
import {Component, Vue} from 'vue-property-decorator'
import { Form } from 'vant'

@Component
export default class GoodsSpecForm extends Vue {
  visible = false
  type = ''
  specIndex = 0
  allSpecAttrName: string[] = []
  form = {
    attrName: ''
  }

  showModal (type = 'add', allSpecAttrName: string[], attrName?: string, index?: number) {
    this.resetField()
    this.type = type
    this.allSpecAttrName = allSpecAttrName
    this.form.attrName = attrName
    this.specIndex = index
    this.visible = true
  }
  resetField () {
    this.form.attrName = ''
  }
  handleCancel () {
    this.visible = false
  }
  validateForm () {
    return new Promise(resolve => {
      (this.$refs.form as Form).validate().then(() => {
        resolve(true)
      })
    })
  }
  async onSubmit () {
    await this.validateForm()
    this.$emit('on-submit', this.type, this.form, this.specIndex)
    this.visible = false
  }
}
